import mixpanel, { type Config } from 'mixpanel-browser'
import { env } from '@/config/env'

const mixpanelConfig = {
  debug: !env.isProduction, // Always false in production
  track_pageview: false, // We'll handle page views manually
  persistence: 'localStorage',
  ignore_dnt: true,
  record_sessions_percent: parseInt(env.mixpanelRecordSessionsPercent),
  record_mask_text_selector: '',
  record_block_selector: '',
} as Partial<Config>

// Only initialize Mixpanel in production
if (env.isProduction && env.mixpanelToken) {
  mixpanel.init(env.mixpanelToken, mixpanelConfig)

  // Set default properties
  mixpanel.register({
    app_name: 'AV Pulse',
    app_version: '1.0.0',
    environment: 'production',
  })
} else if (env.isDev) {
  console.log('Analytics disabled in development environment')
} else if (!env.mixpanelToken) {
  console.warn('Mixpanel token not found. Analytics will be disabled.')
}

export default mixpanel
